import { render, staticRenderFns } from "./DialogConfirmReturned.vue?vue&type=template&id=b16cf562&scoped=true"
import script from "./DialogConfirmReturned.vue?vue&type=script&lang=js"
export * from "./DialogConfirmReturned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16cf562",
  null
  
)

export default component.exports